import { Modal, ModalContent, ModalFooter } from 'components/ui/Modal';
import { IResolutionStatus } from 'containers/CoachingFormContainer/interfaces';
import { getActionStatusIcon } from 'containers/CoachingFormContainer/util';
import { IStatusTypes } from 'containers/CoachingFormStatus/interfaces';
import * as _ from 'lodash';
import * as React from 'react'
import Highlighter from 'react-highlight-words'
import { Alert, Button, ButtonGroup, Card, FormGroup, Input, Label, ModalHeader } from 'reactstrap'
import { HttpRequest } from 'util/http';
import { StatusTypesEndpoint } from 'util/http/endpoints';
import { ContentCardHeader } from '../../components/ui/ContentCardHeader'
import { DataGrid, DataGridSortOrder } from '../../components/ui/DataGrid'
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon'
import { Popover } from '../../components/ui/Popover';
import { QuestionsPopover } from '../../components/ui/QuestionsPopover';
import { Tooltip } from '../../components/ui/Tooltip';
import { IFilters, userData } from '../../util/userData';
import { openCoachingForm } from '../CoachingFormsContainer/lib/utils'
import { CommentCodeSelect, ICommentCodeGroupOption, ICommentCodeOptionType } from './lib/CommentCodeSelect';
import { CommentVisibilityModal } from './lib/CommentVisibilityModal'
import {
  getCommentCodes,
  getCommentCodesByType,
  getCommentDetails,
  getParentSegments,
  ICommentCodeIndex,
  ICommentCodesByType,
  ICommentDetailsValue,
  IParentSegments,
  updateCommentDetail,
  updateFlagOnComment,
  updateHiddenStatus
} from './lib/http'
import DataReportWaitingTimeWarningMessage from "../../shared/Messaging/Warnings/DataReportWaitingTimeWarningMessage";

interface ICommentDetailsContainerProps {
  filters: IFilters
}

interface ICommentDetailsContainerState {
  commentDetails: ICommentDetailsValue[]
  filteredCommentDetails: ICommentDetailsValue[]
  segmentFields: IParentSegments[]
  hiddenSegments: IParentSegments[]
  question: string
  sortBy: keyof ICommentDetailsValue
  sortOrder: DataGridSortOrder
  loading: boolean
  questionId: string
  statId: string
  showQuestionsPopover: boolean
  commentDetailInEditMode: ICommentDetailsValue | null
  questionAndMeasureText: string
  filterText: string
  isSubmittingUpdate: boolean
  toggleEdit: boolean
  flagEdit: boolean
  uchc: number
  hiddenProperties: Array<keyof ICommentDetailsValue>
  actionItemFilter: boolean
  wowFilter: boolean
  perfectScoreFilter: boolean
  salesOpportunityFilter: boolean
  attritionRiskFilter: boolean
  isFlaggedFilter: boolean
  isHiddenFilter: boolean
  hideComments: boolean
  statusTypes: IStatusTypes[]
  statuses: IResolutionStatus[]
  modalOpen: boolean
  commentCodes: ICommentCodesByType[]
  commentCodeTabs: string[]
  allCodes: ICommentCodeIndex[]
  commentCodesLoaded: boolean
  activeTab: string
  displayErrorMessage: boolean
  stagingCodes: string[]
  modal: boolean
  visibileCommentDetail: ICommentDetailsValue | null
  hideCommentReason: string
  visibleError: string
  modalTitle: string
  modalLabel: string
  actionAlertAttachedStatus?: any
  moodFilter: string[]
  codesGroupedByMood: ICommentCodeGroupOption[]
  shouldRunMappingCodesToMoods: boolean
  individualSurveysAccess: boolean
}

export class CommentDetailsContainer extends React.Component<ICommentDetailsContainerProps, ICommentDetailsContainerState> {
  static CommentDetailsContainerColumnsKey = 'CommentDetailsContainerColumnsKey';
  static CommentDetailsContainerSegmentsKey = 'CommentDetailsContainerSegmentsKey';

  state: ICommentDetailsContainerState = {
    loading: false,
    commentDetails: [],
    filteredCommentDetails: [],
    segmentFields: [],
    question: '',
    sortBy: 'period',
    sortOrder: 'asc',
    questionId: '',
    statusTypes: [],
    statuses: [],
    statId: '',
    showQuestionsPopover: true,
    commentDetailInEditMode: null,
    questionAndMeasureText: '',
    filterText: '',
    toggleEdit: false,
    flagEdit: false,
    uchc: 0,
    isSubmittingUpdate: false,
    hiddenProperties: ['period', 'question', 'sat', 'survey', 'branch', 'parentLabel'],
    hiddenSegments: [],
    actionItemFilter: false,
    wowFilter: false,
    perfectScoreFilter: false,
    salesOpportunityFilter: false,
    attritionRiskFilter: false,
    isFlaggedFilter: false,
    isHiddenFilter: false,
    hideComments: true,
    modalOpen: false,
    commentCodes: [],
    allCodes: [],
    commentCodeTabs: [],
    commentCodesLoaded: false,
    activeTab: 'Customer',
    displayErrorMessage: false,
    stagingCodes: [],
    modal: false,
    visibileCommentDetail: null,
    hideCommentReason: '',
    visibleError: '',
    modalTitle: '',
    modalLabel: '',
    moodFilter: [],
    codesGroupedByMood: [],
    shouldRunMappingCodesToMoods: false,
    individualSurveysAccess: false,
  }

  mapCodesToMoodsDebounce = _.debounce(() => { this.mapCodesToMoods() }, 1500);
  componentDidMount() {
    this.setCachedColumnsIfExists()
    this.updateCommentDetails()
    this.loadStatuses()
    this.updateParentSegments()
    this.loadCommentCodes()
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleVisibleModal = this.toggleVisibleModal.bind(this)
  }

  componentDidUpdate(prevProps, prevState: ICommentDetailsContainerState) {
    const { commentDetails, shouldRunMappingCodesToMoods } = this.state;
    if (commentDetails !== prevState.commentDetails) {
      this.getAttachedAlertsStatus();
    }

    if (shouldRunMappingCodesToMoods !== prevState.shouldRunMappingCodesToMoods && shouldRunMappingCodesToMoods) {
      this.mapCodesToMoodsDebounce();
    }

    if (!this.compareObjectsPropertyByProperty(prevProps.filters, this.props.filters)) {
      this.updateCommentDetails();
    }
  }

  compareObjectsPropertyByProperty(obj1: any, obj2: any): boolean {
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    if (obj1Keys.length !== obj2Keys.length) {
      const difference = _.difference(obj1Keys, obj2Keys);
      if (!(difference.length === 1 && difference[0] === 'listOfPeriods')) {
        return false;
      }
    }

    for (let key of obj1Keys) {
      if (key !== 'listOfPeriods') {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
    }

    return true;
  }
  mapCodesToMoods() {
    const persistedMoodFilter = this.props.filters.mood;
    this.setState({ shouldRunMappingCodesToMoods: false }, () => {
      const { codesGroupedByMood } = this.state;
      const commentDetails = { ...this.state.commentDetails };
      const updatedCommentDetails = Object.keys(commentDetails).map(
        (commentDetailIdx) => {
          const currentCommentDetail = { ...commentDetails[commentDetailIdx] };
          currentCommentDetail.moods = currentCommentDetail.codes
            .filter((code) => code !== null)
            .map((shortLabel) => {
              let valueOption: ICommentCodeOptionType;

              codesGroupedByMood.every((groupOption) => {
                const possibleValueOption = groupOption.options.find((o) => o.shortLabel === shortLabel)

                if (possibleValueOption) {
                  valueOption = possibleValueOption;
                  return false;
                }

                return true;
              })
              if (undefined === valueOption) {
                return "neutral";
              } else {
                return valueOption.mood.toLowerCase();
              }

            });
          return currentCommentDetail;
        }
      );
      this.setState({ commentDetails: updatedCommentDetails }, () => {
        if (persistedMoodFilter) {
          this.setState({ moodFilter: [persistedMoodFilter.toLowerCase()] }, () => {
            this.loadAndFilterRows();
          })
        }
      });
    });
  }

  formatDate(dateString) {
    // Extract the date parts
    const dateParts = dateString.split('T')[0].split('-');

    // Create a new Date object without a timezone
    const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

    const formattedDate = (date.getMonth() + 1).toString().padStart(2, '0') + '/'
      + date.getDate().toString().padStart(2, '0') + '/'
      + date.getFullYear();
    return formattedDate;
  };

  getAttachedAlertsStatus() {
    const commentDetails = Object.assign(this.state.commentDetails)
    const ids = commentDetails.reduce((acc, curr) => {
      return acc.concat(curr.id)
    }, [])
    const method = 'POST';
    const data = { current_project: userData.getCurrentProject(), coachingFormsIds: ids.join(',') };
    if (ids.length > 0) {
      HttpRequest.fetch('/scripts/coaching_forms/get_attached_alerts_status', { data, method }).then((res) => {
        this.setState({ actionAlertAttachedStatus: res });
        let updatedRecords = this.state.commentDetails;
        updatedRecords.forEach((record) => {
          if (res.hasOwnProperty(record.id)) {
            // if there is an Action Alert related to current Coaching Form, mark it as an Action Item
            record.ai = '1'
          }
        })
        this.setState({ commentDetails: updatedRecords })
      })
    }
  }

  setCachedColumnsIfExists() {
    const columnsStr = localStorage.getItem(CommentDetailsContainer.CommentDetailsContainerColumnsKey)
    const segmentStr = localStorage.getItem(CommentDetailsContainer.CommentDetailsContainerSegmentsKey)

    try {
      const columns: Array<keyof ICommentDetailsValue> = JSON.parse(columnsStr)
      const segments = JSON.parse(segmentStr)

      if (columns instanceof Array) {
        this.setState({ hiddenProperties: columns });
      }

      if (segments instanceof Array) {
        this.setState({ hiddenSegments: segments })
      }
    } catch { /* */ }
  }

  saveCachedColumns(columns: Array<keyof ICommentDetailsValue>) {
    const columnsStr = JSON.stringify(columns)

    localStorage.setItem(CommentDetailsContainer.CommentDetailsContainerColumnsKey, columnsStr)
  }

  loadStatuses() {
    HttpRequest.fetch<IStatusTypes[]>(StatusTypesEndpoint)
      .then((statusTypes) => this.setState({ statusTypes }))

    HttpRequest.fetch<IResolutionStatus[]>('/scripts/coaching_form/status_get_all')
      .then((statuses) => this.setState({ statuses }))
  }

  saveCachedSegments(segments) {
    const segmentsStr = JSON.stringify(segments)

    localStorage.setItem(CommentDetailsContainer.CommentDetailsContainerSegmentsKey, segmentsStr)
  }

  updateParentSegments() {
    getParentSegments().then((segmentFields) => {
      this.setState({ segmentFields })
    })
  }

  loadCommentCodes() {
    getCommentCodesByType().then((commentCodes) => {
      const tabs = []
      commentCodes.map((value) => {
        tabs.push(value.typeName)
      })
      this.setState({ commentCodes, commentCodesLoaded: true, commentCodeTabs: tabs })
    })

    getCommentCodes(true).then((allCodes) => {
      const codesGroupedByMood = _.groupBy(allCodes, 'mood');
      const groupedOptions = Object.keys(codesGroupedByMood).map((mood) => {
        const options = codesGroupedByMood[mood].map((codeIndex) => {
          return {
            label: codeIndex.shortLabel,
            value: codeIndex.shortLabel,
            ...codeIndex,
          };
        });
        return { label: mood, options };
      });
      this.setState({
        allCodes,
        codesGroupedByMood: groupedOptions,
        shouldRunMappingCodesToMoods: true,
      });
    });
  }

  updateCommentDetails(props = this.props) {
    this.setState({ loading: true })
    const { hideComments } = this.state

    getCommentDetails(props.filters, hideComments).then((res) => {
      const { values: commentDetails, q: questionId, stat: statId, question, commentType, measure, hideQuestionSelection, toggleEdit, flagEdit, uchc } = res

      let questionAndMeasureText = ''//commentType;
      let showQuestionsPopover = false;

      if (hideQuestionSelection === true) {
        questionAndMeasureText += `${question}: ${measure}`
        showQuestionsPopover = false;
      } else {
        questionAndMeasureText = '';
        showQuestionsPopover = true;
      }

      let filterText = '';
      const openEndedQuestion = res.openEndedQuestion || 'All Questions';
      if (res.segmentCategory && res.segmentName) {
        filterText += ' | ' + res.segmentCategory + ': ' + res.segmentName;
      }

      filterText += ' | ' + openEndedQuestion;

      this.setState({
        commentDetails,
        question,
        questionId,
        statId,
        showQuestionsPopover,
        filterText,
        questionAndMeasureText,
        toggleEdit,
        flagEdit,
        uchc,
        loading: false,
        shouldRunMappingCodesToMoods: true,
        individualSurveysAccess: res.individualSurveysAccess,
      });

      this.loadAndFilterRows()
    }).finally(() => {
      const hideAllPeriodsWarning = new CustomEvent('hideAllPeriodsWarning', {});
      window.dispatchEvent(hideAllPeriodsWarning);
      const allDataLoadedEvent = new CustomEvent('allDataLoaded', {});
      window.dispatchEvent(allDataLoadedEvent);
    })
  }

  submitCommentDetailForUpdate(commentDetail: ICommentDetailsValue) {
    const { commentDetailInEditMode } = this.state;
    this.setState({ isSubmittingUpdate: true })

    return updateCommentDetail(commentDetailInEditMode)
      .then(() => {
        const { commentDetails } = this.state
        const commentDetailIndex = commentDetails.findIndex((cd) => cd.id === commentDetail.id)

        commentDetail.code1 = commentDetailInEditMode.codes[0] || null
        commentDetail.code2 = commentDetailInEditMode.codes[1] || null
        commentDetail.code3 = commentDetailInEditMode.codes[2] || null
        commentDetail.code4 = commentDetailInEditMode.codes[3] || null
        commentDetail.code5 = commentDetailInEditMode.codes[4] || null
        commentDetail.code6 = commentDetailInEditMode.codes[5] || null
        commentDetail.codes = commentDetailInEditMode.codes

        if (commentDetailIndex >= 0) {
          commentDetails[commentDetailIndex] = commentDetail

          this.setState({ commentDetails })
        }
      })
      .finally(() => this.setState({ isSubmittingUpdate: false, commentDetailInEditMode: null }))
  }

  isHiddenColumn(prop: keyof ICommentDetailsValue) {
    return this.state.hiddenProperties.indexOf(prop) >= 0
  }

  isHiddenSegment(prop: string) {
    const parentSegment = this.state.hiddenSegments.find((current) => {
      return current.avid === prop
    })

    return parentSegment === undefined
  }

  toggleHiddenSegment(prop: IParentSegments) {
    const { hiddenSegments } = this.state
    const indexOfProp = hiddenSegments.map((segment) => segment.avid).indexOf(prop.avid)

    if (indexOfProp >= 0) {
      hiddenSegments.splice(indexOfProp, 1)
    } else {
      hiddenSegments.push(prop)
    }

    this.setState({ hiddenSegments })
    this.saveCachedSegments(hiddenSegments)
  }

  toggleHiddenColumn(prop: keyof ICommentDetailsValue) {
    const { hiddenProperties } = this.state
    const indexOfProp = hiddenProperties.indexOf(prop)

    if (indexOfProp >= 0) {
      hiddenProperties.splice(indexOfProp, 1)
    } else {
      hiddenProperties.push(prop)
    }

    this.setState({ hiddenProperties })
    this.saveCachedColumns(hiddenProperties)
  }

  toggleVisibleModal(currentDetail: ICommentDetailsValue) {
    const { modal } = this.state

    let title = ''
    let label = ''
    if (currentDetail) {
      title = currentDetail.isHidden === 1 ? 'Unhide Comment' : 'Hide Comment'
      label = currentDetail.isHidden === 1 ? 'Reason for Unhiding Comment' : 'Reason for Hiding Comment'
    }

    this.setState({ modal: !modal, visibileCommentDetail: currentDetail, modalLabel: label, modalTitle: title })
  }

  toggleReasonModal() {
    const { modal } = this.state

    this.setState({ modal: !modal })
  }

  loadAndFilterRows() {
    const {
      wowFilter,
      actionItemFilter,
      perfectScoreFilter,
      salesOpportunityFilter,
      attritionRiskFilter,
      isFlaggedFilter,
      isHiddenFilter,
      moodFilter,
    } = this.state;

    const filteredCommentDetails = this.state.commentDetails.filter((commentDetail) => {
      const isActionItem = commentDetail.ai === '1'
      const hasWow = commentDetail.wow === '1'
      const hasPerfectScore = commentDetail.ps === '1'
      const isSalesOpportunity = commentDetail.is_sales_opportunity === 1;
      const isAttritionRisk = commentDetail.is_attrition_risk === 1;
      const isFlagged = commentDetail.isFlagged
      const isHidden = commentDetail.isHidden
      const moods = commentDetail.moods;

      if (actionItemFilter && !isActionItem) {
        return false
      }

      if (wowFilter && !hasWow) {
        return false
      }

      if (perfectScoreFilter && !hasPerfectScore) {
        return false
      }

      if (salesOpportunityFilter && !isSalesOpportunity) {
        return false
      }

      if (attritionRiskFilter && !isAttritionRisk) {
        return false
      }

      if (isFlaggedFilter && !isFlagged) {
        return false
      }

      if (isHiddenFilter && !isHidden) {
        return false
      }

      if (moodFilter.length > 0 && _.intersection(moods, moodFilter).length === 0) {
        return false;
      }

      return true
    })

    this.setState({ filteredCommentDetails }, () => {
      const filteredCommentDetailsEvent = new CustomEvent(
        'filteredCommentDetails',
        {
          detail: filteredCommentDetails.reduce((acc, curr) => {
            return acc.concat(curr.id)
          }, [])
        }
      );
      window.dispatchEvent(filteredCommentDetailsEvent);
    })
  }

  toggleActionItemFilter(actionItemFilter = !this.state.actionItemFilter) {
    this.state.actionItemFilter = actionItemFilter
    this.setState({ actionItemFilter })

    this.loadAndFilterRows()
  }

  toggleWowFilter(wowFilter = !this.state.wowFilter) {
    this.state.wowFilter = wowFilter
    this.setState({ wowFilter })

    this.loadAndFilterRows()
  }

  togglePerfectScoreFilter(perfectScoreFilter = !this.state.perfectScoreFilter) {
    this.state.perfectScoreFilter = perfectScoreFilter
    this.setState({ perfectScoreFilter })

    this.loadAndFilterRows()
  }

  toggleSalesOpportunityFilter(salesOpportunityFilter = !this.state.salesOpportunityFilter) {
    this.state.salesOpportunityFilter = salesOpportunityFilter
    this.setState({ salesOpportunityFilter })

    this.loadAndFilterRows()
  }

  toggleAttritionRiskFilter(attritionRiskFilter = !this.state.attritionRiskFilter) {
    this.state.attritionRiskFilter = attritionRiskFilter
    this.setState({ attritionRiskFilter })

    this.loadAndFilterRows()
  }

  toggleFlaggedFilter(isFlaggedFilter = !this.state.isFlaggedFilter) {
    this.state.isFlaggedFilter = isFlaggedFilter
    this.setState({ isFlaggedFilter })

    this.loadAndFilterRows()
  }

  toggleHiddenFilter(isHiddenFilter = !this.state.isHiddenFilter) {
    this.state.isHiddenFilter = isHiddenFilter
    this.setState({ isHiddenFilter })

    this.loadAndFilterRows()
  }

  toggleHiddenComments(hideComments = !this.state.hideComments) {
    this.state.hideComments = hideComments
    this.setState({ hideComments })

    this.updateCommentDetails()
  }

  setCommentDetailInEditMode(commentDetailInEditMode: ICommentDetailsValue | null) {
    let stagingCodes = []
    if (commentDetailInEditMode) {
      //copy
      commentDetailInEditMode = { ...commentDetailInEditMode }
      stagingCodes = [...commentDetailInEditMode.codes]
    }

    this.setState({ commentDetailInEditMode, stagingCodes })
  }

  toggleFlag(commentDetail: ICommentDetailsValue | null) {
    const { commentDetails, filteredCommentDetails } = this.state
    const flagComment = (commentDetail) ? !commentDetail.isFlagged : false

    updateFlagOnComment(commentDetail, flagComment).then((updatedCommentDetail) => {
      this.updateCommentDetails(this.props)
    })
  }

  toggleVisibility(reason: string, callback: () => void) {
    const { visibileCommentDetail, commentDetails, filteredCommentDetails } = this.state

    updateHiddenStatus(visibileCommentDetail, reason).then((updatedCommentDetail) => {
      const extRefId = updatedCommentDetail.id

      const commentDetailsIndex = commentDetails.findIndex((value, index) => {
        return value.id === extRefId
      })

      const filteredCommentDetailsIndex = filteredCommentDetails.findIndex((value, index) => {
        return value.id === extRefId
      })

      filteredCommentDetails[filteredCommentDetailsIndex] = updatedCommentDetail
      commentDetails[commentDetailsIndex] = updatedCommentDetail
      this.setState({ commentDetails, filteredCommentDetails, visibileCommentDetail: null, modal: false, visibleError: '', hideCommentReason: '' }, () => callback())
      this.loadAndFilterRows()
      this.updateCommentDetails(this.props)
    })
  }

  updateCommentDetailInEditMode(codes: Array<string | null>) {
    const { commentDetailInEditMode } = this.state;

    if (commentDetailInEditMode) {
      commentDetailInEditMode.codes = codes

      this.setState({ commentDetailInEditMode, stagingCodes: codes })
    }
  }

  resetFilterAndSortState() {
    this.setState({
      sortOrder: 'asc',
      sortBy: 'period',
      actionItemFilter: false,
      wowFilter: false,
      perfectScoreFilter: false,
      salesOpportunityFilter: false,
      attritionRiskFilter: false,
      isFlaggedFilter: false,
      isHiddenFilter: false,
      hideComments: true,
    },
      () => this.loadAndFilterRows())
  }

  getStatus(value: ICommentDetailsValue): number {
    const { statuses } = this.state

    const status = statuses.find((st) => (st.form === value.id))
    return (status) ? status.resolutionId : ((value.ai === '1') ? 0 : 3)
  }

  getStatusName(value: ICommentDetailsValue): IStatusTypes['status'] {
    const { statusTypes, actionAlertAttachedStatus } = this.state

    if (actionAlertAttachedStatus && actionAlertAttachedStatus.hasOwnProperty(value.id)) {
      if (actionAlertAttachedStatus[value.id].includes('New')) {
        return 'New'
      } else {
        if (actionAlertAttachedStatus[value.id].includes('Pending')) {
          return 'Pending'
        } else {
          if (actionAlertAttachedStatus[value.id].includes('Resolved')) {
            return 'Resolved'
          } else {
            if (actionAlertAttachedStatus[value.id].includes('No Action Needed')) {
              return 'No Action Needed'
            } else {
              if (actionAlertAttachedStatus[value.id].includes('N/A') || actionAlertAttachedStatus[value.id].includes('n/a')) {
                return 'N/A'
              } else {
                if (statusTypes.length > 0) {
                  const statusId = this.getStatus(value)
                  const statusType = this.state.statusTypes.find((st) => (statusId !== undefined && statusId === st.id))

                  if (statusType) {
                    return statusType.status
                  }
                }
              }
            }
          }
        }
      }

    } else {
      if (statusTypes.length > 0) {
        const statusId = this.getStatus(value)
        const statusType = this.state.statusTypes.find((st) => (statusId !== undefined && statusId === st.id))

        if (statusType) {
          return statusType.status
        }
      }
    }


    return ''
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  toggleModal() {
    const { modalOpen } = this.state
    this.setState({ modalOpen: !modalOpen });
  }

  renderStatusColumn(record: ICommentDetailsValue) {
    const statusName = this.getStatusName(record)
    const isActionItem = record.ai === '1'
    const isWow = record.wow === '1'
    const isPerfectScore = record.ps === '1'
    const isSalesOpportunity = record.is_sales_opportunity === 1;
    const isAttritionRisk = record.is_attrition_risk === 1;
    const isFlagged = record.isFlagged === 1

    return (
      <article>
        <Tooltip text={isActionItem ? 'Action Item' : 'Not an Action Item'}>
          <FontAwesomeIcon icon="exclamation-triangle" color="orange" muted={!isActionItem} />
        </Tooltip>
        <Tooltip text={isSalesOpportunity ? 'Sales Opportunity' : 'Not a Sales Opportunity'}>
          <FontAwesomeIcon icon="dollar-sign" color="green" muted={!isSalesOpportunity} />
        </Tooltip>
        <Tooltip text={isAttritionRisk ? 'Attrition Risk' : 'Not an Attrition Risk'}>
          <FontAwesomeIcon icon="asterisk" color="red" muted={!isAttritionRisk} />
        </Tooltip>
        <Tooltip text={isWow ? 'WOW' : 'No WOW'}>
          <FontAwesomeIcon icon="star" color="yellow" muted={!isWow} />
        </Tooltip>
        <Tooltip text={isPerfectScore ? 'Perfect Score' : 'Not a Perfect Score'}>
          <FontAwesomeIcon icon="check" color="green" muted={!isPerfectScore} />
        </Tooltip>
        <Tooltip text={statusName}>
          {getActionStatusIcon(statusName)}
        </Tooltip>
      </article>
    )
  }

  setActiveTab(e) {
    this.setState({ activeTab: $(e.currentTarget).text() })
  }

  handleCodeClick(e) {
    const shortLabel = $(e.currentTarget).text()

    this.modifyStagedCodes(shortLabel)
  }

  modifyStagedCodes(shortLabel: string) {
    const { stagingCodes } = this.state
    let displayErrorMessage = false
    if (stagingCodes.includes(shortLabel)) {
      //NOTE: Splice value out of array
      const index = stagingCodes.findIndex((value) => {
        return value === shortLabel
      })

      stagingCodes.splice(index, 1)
    } else {
      //NOTE: If codes < 3 then add else do nothing
      if (stagingCodes.includes(null)) {
        //NOTE: Splice value out of array
        const index = stagingCodes.findIndex((value) => {
          return value === null
        })

        stagingCodes.splice(index, 1)
        stagingCodes.push(shortLabel)
      } else {
        if (stagingCodes.length < 6) {
          stagingCodes.push(shortLabel)
        } else {
          displayErrorMessage = true
        }
      }
    }

    this.setState({ stagingCodes, displayErrorMessage })
  }

  closeErrorMessage() {
    this.setState({ displayErrorMessage: false })
  }

  renderSelectedIcon(label) {
    const { stagingCodes } = this.state
    if (stagingCodes && stagingCodes.includes(label)) {
      return (
        <i className="fas fa-fw fa-check fa-lg fa-fw icon-green"></i>
      )
    }

    return null
  }

  findCategory(code) {
    const { allCodes } = this.state

    const label = allCodes.find((value) => {
      return value.shortLabel === code
    })

    return (label) ? label.typeLabel : ''
  }

  findCode(shortLabel: string) {
    const { allCodes } = this.state

    const code = allCodes.find((value) => {
      return value.shortLabel === shortLabel
    })

    return code
  }

  drawSelectedCode(shortLabel: string) {
    const code = this.findCode(shortLabel)
    if (code) {
      const backgroundColor = (code.mood === 'Compliment') ? CommentCodeSelect.MoodColors.compliment : (code.mood === 'Suggestion' ? CommentCodeSelect.MoodColors.suggestion : CommentCodeSelect.MoodColors.neutral)
      return (
        <span style={{ backgroundColor, color: '#1B3767', margin: '0 5px', padding: '5px' }}>
          {shortLabel + ' (' + code.typeLabel + ')'}&nbsp;<a className="commentDetailsLink" style={{ color: '#1B3767' }}
            onClick={() => this.modifyStagedCodes(shortLabel)}>X</a>
        </span>
      )
    }
  }

  cancelModal() {
    const { commentDetailInEditMode } = this.state
    let { stagingCodes } = this.state

    if (commentDetailInEditMode) {
      stagingCodes = [...commentDetailInEditMode.codes]
    }

    this.setState({ stagingCodes }, () => this.toggleModal())
  }

  setCommentCodes() {
    const { commentDetailInEditMode, stagingCodes } = this.state

    commentDetailInEditMode.codes = stagingCodes

    this.setState({ commentDetailInEditMode, stagingCodes: [] }, () => {
      this.loadAndFilterRows()
      this.toggleModal()
    })
  }

  renderCommentCodes(title: string, codes: ICommentCodeIndex[], color: string) {
    return (
      <div className="row">
        <h5 style={{ color }}>{title}</h5>
        {codes.map((code) => {
          return (
            <>
              <div key={code.shortLabel + code.id} className="col s6" >
                <section style={{ padding: '10px', fontSize: '0.8rem' }}>
                  <a className="commentDetailsLink" style={{ color }} onClick={(e) => this.handleCodeClick(e)} title={code.longLabel}>{code.shortLabel}</a>&nbsp;{this.renderSelectedIcon(code.shortLabel)}
                </section>
              </div>
            </>
          )
        })}
      </div>
    )
  }

  updateHideReason(e) {

    this.setState({ hideCommentReason: e.currentTarget.value })
  }
  toggleMoodFilter(mood: string) {
    const { moodFilter } = this.state;
    let updatedMoodFilter = [];
    if (moodFilter.includes(mood)) {
      updatedMoodFilter = moodFilter.filter((filter) => filter !== mood);
    } else {
      updatedMoodFilter = [...moodFilter, mood];
    }
    this.setState({ moodFilter: updatedMoodFilter }, () => {
      this.loadAndFilterRows();
    });
  }

  resetMoodFilters() {
    this.setState({ moodFilter: [] }, () => {
      this.loadAndFilterRows();
    });
  }

  render() {
    const { commentDetailInEditMode, isSubmittingUpdate, toggleEdit, flagEdit, uchc, segmentFields, activeTab, displayErrorMessage, modal, individualSurveysAccess } = this.state
    const { modalTitle, modalLabel, visibleError, hideComments, isHiddenFilter, isFlaggedFilter, actionItemFilter, wowFilter, perfectScoreFilter, salesOpportunityFilter, attritionRiskFilter, stagingCodes, hideCommentReason } = this.state
    const commentDetailInEditModeId = commentDetailInEditMode ? commentDetailInEditMode.commentId : undefined;

    const codesHeader = (
      <span>
        <span>Codes&nbsp;</span>
        <span className="text-muted" style={{ fontSize: '0.9em' }}>(max: 6)</span>
      </span>
    )
    const displayMessage = displayErrorMessage ? '' : 'none'
    const hideCommentsBtn = (hideComments) ? 'eye-slash' : 'eye'
    const hideCommentsText = (hideComments) ? 'Click to show hidden comment' : 'Click to hide comment'
    const hideCommentsColor = (hideComments) ? 'grey' : 'primary'

    const moods = {
      suggestion: { label: 'Suggestion' },
      compliment: { label: 'Compliment' },
      neutral: { label: 'Neutral' },
    };

    return (
      <>
        <section className="blacklight page-container" >
          <section className="containerv2">
            <Card>
              <ContentCardHeader borderBottom header={
                <section className="d-md-flex justify-content-between">
                  <header>
                    <h2 className="d-inline-block mr-2">
                      <span>Comments</span>
                      <small className="text-muted">{this.state.filterText}</small>
                      {this.state.loading &&
                        <FontAwesomeIcon icon="cog" size="sm" verticalAlign="middle" spin />
                      }
                    </h2>
                  </header>
                  <div style={{ maxWidth: '20%' }}>
                    <DataReportWaitingTimeWarningMessage
                      isOpen={this.state.loading && userData.getFilters().period.includes('YTD')}
                      selectedOption={"annual"} />
                  </div>
                  <article>
                    {uchc === 1 &&
                      <Button className="mr-3" color={hideCommentsColor} active={hideComments} onClick={() => this.toggleHiddenComments()}>
                        <Tooltip text={hideCommentsText}>
                          <FontAwesomeIcon icon={hideCommentsBtn} fixedWidth />
                        </Tooltip>
                      </Button>
                    }
                    <Popover btnText="Fields" className="mr-3">
                      <section style={{ fontSize: '1rem', minWidth: 150, maxHeight: '250px', overflowY: 'scroll' }}>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('id')} onChange={() => this.toggleHiddenColumn('id')} />
                            <span>&nbsp;ID</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('period')} onChange={() => this.toggleHiddenColumn('period')} />
                            <span>&nbsp;Interview Date</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('question')} onChange={() => this.toggleHiddenColumn('question')} />
                            <span>&nbsp;Question</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('sat')} onChange={() => this.toggleHiddenColumn('sat')} />
                            <span>&nbsp;{this.state.question}</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('survey')} onChange={() => this.toggleHiddenColumn('survey')} />
                            <span>&nbsp;Survey</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('branch')} onChange={() => this.toggleHiddenColumn('branch')} />
                            <span>&nbsp;Unit</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('parentLabel')} onChange={() => this.toggleHiddenColumn('parentLabel')} />
                            <span>&nbsp;Org Parent</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('comment')} onChange={() => this.toggleHiddenColumn('comment')} />
                            <span>&nbsp;Comment</span>
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label>
                            <Input type="checkbox" checked={!this.isHiddenColumn('code1')} onChange={() => this.toggleHiddenColumn('code1')} />
                            <span>&nbsp;Codes</span>
                          </Label>
                        </FormGroup>
                        <section>
                          <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Segments</span>
                          {segmentFields.map((field) => {
                            return (
                              <FormGroup check key={field.avid}>
                                <Label>
                                  <Input type="checkbox" checked={!this.isHiddenSegment(field.avid)} onChange={() => this.toggleHiddenSegment(field)} />
                                  <span>&nbsp;{field.label}</span>
                                </Label>
                              </FormGroup>
                            )
                          })}
                        </section>
                      </section>
                    </Popover>
                    {/* {this.state.questionAndMeasureText} */}
                    {this.state.showQuestionsPopover && this.state.questionId &&
                      <QuestionsPopover<true> multi
                        questionId={this.state.questionId}
                        statId={[this.state.statId]} dataUrl="get_categories" />
                    }
                    <Popover btnText="Action Filters">
                      <section className="d-flex" style={{ justifyContent: 'flex-end' }}>
                        <ButtonGroup className="mb-3 right">
                          <Button color="white" id="resetFilterBtns" onClick={() => this.resetFilterAndSortState()}>
                            <FontAwesomeIcon icon="ban" fixedWidth style={{ color: 'red' }} />
                            <span>&nbsp;Reset Action Filters</span>
                          </Button>
                        </ButtonGroup>
                      </section>
                      <section className="d-flex justify-content-between">
                        <ButtonGroup className="mb-3">
                          <Button color="white" active={actionItemFilter} onClick={() => this.toggleActionItemFilter()}>
                            <FontAwesomeIcon icon="exclamation-triangle" color="orange" fixedWidth />
                            <span>&nbsp;Action Alert</span>
                          </Button>
                          <Button color="white" active={salesOpportunityFilter} onClick={() => this.toggleSalesOpportunityFilter()}>
                            <FontAwesomeIcon icon="dollar-sign" color="green" fixedWidth />
                            <span>&nbsp;Sales Opportunity</span>
                          </Button>
                          <Button color="white" active={attritionRiskFilter} onClick={() => this.toggleAttritionRiskFilter()}>
                            <FontAwesomeIcon icon="asterisk" color="red" fixedWidth />
                            <span>&nbsp;Attrition Risk</span>
                          </Button>
                          <Button color="white" active={wowFilter} onClick={() => this.toggleWowFilter()}>
                            <FontAwesomeIcon icon="star" color="yellow" fixedWidth />
                            <span>&nbsp;WOW</span>
                          </Button>
                          <Button color="white" active={perfectScoreFilter} onClick={() => this.togglePerfectScoreFilter()}>
                            <FontAwesomeIcon icon="check" color="green" fixedWidth />
                            <span>&nbsp;Perfect Score</span>
                          </Button>
                          {flagEdit &&
                            <Button
                              color="white-p"
                              active={isFlaggedFilter}
                              onClick={() => { this.toggleFlaggedFilter() }}

                            >
                              <FontAwesomeIcon
                                icon="flag"
                                color="purple"
                                fixedWidth
                              />
                              <span>&nbsp;Is Flagged</span>
                            </Button>
                          }
                          {uchc === 1 &&
                            <Button color="white" active={isHiddenFilter} onClick={() => this.toggleHiddenFilter()}>
                              <FontAwesomeIcon icon="eye-slash" color="primary" fixedWidth />
                              <span>&nbsp;Hidden Comments</span>
                            </Button>
                          }
                        </ButtonGroup>
                      </section>
                    </Popover>
                    <Popover btnText="Mood Filters">
                      <section className="d-flex" style={{ justifyContent: 'flex-end' }}>
                        <ButtonGroup className="mb-3 right">
                          <Button color="white" onClick={() => this.resetMoodFilters()}>
                            <FontAwesomeIcon icon="ban" fixedWidth style={{ color: 'red' }} />
                            <span>&nbsp;Reset Mood Filters</span>
                          </Button>
                        </ButtonGroup>
                      </section>
                      <section className="d-flex justify-content-between">
                        <ButtonGroup className="mb-3">
                          {Object.keys(moods).map((mood) => {
                            return (
                              <Button
                                color="white"
                                active={this.state.moodFilter.includes(mood)}
                                onClick={() => this.toggleMoodFilter(mood)}
                              >
                                <img src={`images/${mood}_circle.png?v=3.1`} alt={mood} />
                                <span>&nbsp;{moods[mood].label}</span>
                              </Button>
                            );
                          })}
                        </ButtonGroup>
                      </section>
                    </Popover>
                  </article>
                </section>
              } />

              <DataGrid<ICommentDetailsValue>
                records={this.state.filteredCommentDetails}
                sortBy={this.state.sortBy}
                sortOrder={this.state.sortOrder}
                hideInputs={false}
                onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder })}
                showSubComponent={({ commentId }) => commentId === commentDetailInEditModeId}
                subComponent={() =>
                  <span />
                }
                columns={[
                  {
                    property: 'id', header: 'ID', hidden: this.isHiddenColumn('id'), render: (record) =>
                      <Highlighter
                        highlightClassName="highlight"
                        searchWords={[this.props.filters.search]}
                        textToHighlight={String(record.id)}
                      />
                  },
                  {
                    property: 'period', header: 'Date', hidden: this.isHiddenColumn('period'), render: (record) =>
                      <span style={{ whiteSpace: 'nowrap' }}>{this.formatDate(record.period)}</span>
                  },
                  { property: 'question', header: 'Question', hidden: this.isHiddenColumn('question') },
                  {
                    property: 'comment', header: 'Comment', hidden: this.isHiddenColumn('comment'), align: 'left', render: (record) =>
                      <section>
                        <Highlighter
                          highlightClassName="highlight"
                          searchWords={[this.props.filters.search]}
                          textToHighlight={record.comment}
                        />
                      </section>
                  },
                  {
                    property: 'code1', header: codesHeader, width: 300, hidden: this.isHiddenColumn('code1'), render: (record) => {
                      const isInEditMode = record.commentId === commentDetailInEditModeId
                      const codes = isInEditMode ? commentDetailInEditMode.codes : record.codes

                      return (
                        <section>
                          <CommentCodeSelect
                            disabled={!isInEditMode}
                            values={codes}
                            onChange={(newCodes) => this.updateCommentDetailInEditMode(newCodes)}
                          />
                          {isInEditMode ?
                            <a className="link" style={{ float: 'right' }} onClick={() => this.toggleModal()}>Select Comment Codes</a>
                            : null}
                        </section>
                      )
                    }
                  },
                  { property: 'sat', header: this.state.question, hidden: this.isHiddenColumn('sat') },
                  { property: 'survey', header: 'Survey', hidden: this.isHiddenColumn('survey') },
                  { property: 'branch', header: 'Unit', hidden: this.isHiddenColumn('branch') },
                  { property: 'parentLabel', header: 'Org Parent', hidden: this.isHiddenColumn('parentLabel') },
                  { header: 'Statuses', render: (record) => this.renderStatusColumn(record) },
                  {
                    property: 'segments', header: 'Segments', hidden: this.state.hiddenSegments.length === 0, render: (record) => {
                      return (
                        < section style={{ fontSize: '12px' }}>
                          {
                            record.segments.map((segment) => {
                              if (!this.isHiddenSegment(segment.columnValue)) {
                                return <section key={segment.columnValue + segment.value}><b>{segment.columnHeader}:</b>&nbsp;{segment.value}</section>
                              }
                            })
                          }
                        </section>
                      )
                    }
                  },
                  {
                    sortable: false, header: '', render: (record) => {
                      const { id, study, commentId } = record
                      const isInEditMode = commentDetailInEditModeId === commentId
                      const flagMuted = true
                      const flagColor = record.isFlagged ? 'purple' : 'white'
                      const idPrefix = `${record.id}-`
                      const viewBtnId = `${idPrefix}view-btn`
                      const editBtnId = `${idPrefix}edit-btn`
                      const flagBtnId = `${idPrefix}flag-btn`
                      const flagText = (record.isFlagged) ? `Click to unflag survey` : 'Click to flag survey'
                      const visibleBtnId = `${idPrefix}vis-btn`
                      const visibleText = (record.isHidden === 1) ? 'Click to unhide comment' : 'Click to hide comment'
                      const visibleIcon = (record.isHidden === 1) ? 'eye-slash' : 'eye'
                      const visibleColor = (record.isHidden === 1) ? 'grey' : 'primary'

                      return (
                        <section className="d-flex justify-content-start align-items-center">
                          {isInEditMode && this.state.toggleEdit &&
                            <>
                              <Button color="success" className="ml-2"
                                disabled={isSubmittingUpdate}
                                onClick={() => this.submitCommentDetailForUpdate(record)}>
                                <span>Submit&nbsp;</span>
                                {isSubmittingUpdate &&
                                  <FontAwesomeIcon icon="sync" fixedWidth size="sm" spin />
                                }
                                {!isSubmittingUpdate &&
                                  <FontAwesomeIcon icon="check-circle" fixedWidth size="sm" />
                                }
                              </Button>
                              <Button color="white" className="ml-2"
                                disabled={isSubmittingUpdate}
                                onClick={() => this.setCommentDetailInEditMode(null)}>
                                <span>Cancel</span>
                              </Button>
                            </>
                          }
                          {(!isInEditMode && individualSurveysAccess) &&
                            <>
                              <Button color="white" id={viewBtnId} className="ml-2"
                                onClick={() => { openCoachingForm(id, { abbr_survey: study, isFlagged: record.isFlagged, flagEdit, uchc, hasCommentHidden: record.hasCommentHidden }) }}>
                                <Tooltip position="topLeft" text="View">
                                  <FontAwesomeIcon icon="search" fixedWidth size="sm" />
                                </Tooltip>
                              </Button>
                            </>
                          }
                          {!isInEditMode && toggleEdit &&
                            <>
                              <Button color="warning" id={editBtnId} className="ml-2"
                                onClick={() => this.setCommentDetailInEditMode(record)}>
                                <Tooltip position="topLeft" text="Edit">
                                  <FontAwesomeIcon icon="pencil-alt" fixedWidth size="sm" />
                                </Tooltip>
                              </Button>
                            </>
                          }
                          {!isInEditMode && flagEdit &&
                            <>
                              <Button
                                color={flagColor}
                                id={flagBtnId}
                                className="ml-2"
                                onClick={() => this.toggleFlag(record)}
                              >
                                <Tooltip position="topLeft" text={flagText}>
                                  <FontAwesomeIcon icon="flag" fixedWidth size="sm" />
                                </Tooltip>
                              </Button>
                            </>
                          }
                          {!isInEditMode && uchc === 1 &&
                            <>
                              <Button color={visibleColor} id={visibleBtnId} className="ml-2"
                                onClick={() => this.toggleVisibleModal(record)}>
                                <Tooltip position="topLeft" text={visibleText}>
                                  <FontAwesomeIcon icon={visibleIcon} fixedWidth size="sm" />
                                </Tooltip>
                              </Button>
                            </>
                          }
                        </section>
                      )
                    }
                  }
                ]}
              />
            </Card>
          </section>
        </section >
        <Modal open={modal}>
          <CommentVisibilityModal
            label={modalLabel}
            title={modalTitle}
            resetInputs={modal}
            cancelModal={() => this.toggleVisibleModal(null)}
            submitModal={(reason, callback) => this.toggleVisibility(reason, callback)}
          />
        </Modal>
        <Modal open={this.state.modalOpen}>
          <ModalHeader style={{ padding: '10px' }}>
            <section style={{ padding: '10px 0' }} key="chooseCommentCodesTitle">Select Up to Six Comment Codes</section>
            <section style={{ paddingBottom: '10px', fontSize: '70%' }}>
              Currently Selected:&nbsp;
              {this.state.stagingCodes &&
                <>
                  {this.state.stagingCodes.map((value) => {
                    return (
                      <>
                        {(value !== null) ? this.drawSelectedCode(value) : null}
                      </>
                    )
                  })}
                </>
              }
            </section>
            <Alert color="danger" style={{ color: '#721c24', backgroundColor: '#f8d7da', borderColor: '#f5c6cb', padding: '.75rem 1.25rem', fontSize: '1.0rem', display: displayMessage }}>
              You’ve reached the maximum 6 codes.  Before adding another code, you must first remove one of the currently selected codes. <a className="link" onClick={() => this.closeErrorMessage()} style={{ float: 'right' }}>Close</a>
            </Alert>
          </ModalHeader>
          <ModalContent style={{ padding: '5px 20px' }}>
            <section>
              {this.state.commentCodesLoaded &&
                <ul className="tabs row" style={{ border: '1px solid rgb(50, 122, 183)' }}>
                  {this.state.commentCodeTabs.map((value) => {
                    const width = Math.round((this.state.commentCodeTabs.length > 0 ? 100.0 / this.state.commentCodeTabs.length : 100)) + '%'
                    const href = '#' + value
                    const activeClass = value === activeTab
                    const activeStyle = { color: '#fff', backgroundColor: '#327AB7' }
                    const inactiveStyle = { color: '#327AB7', backgroundColor: '#fff' }
                    const style = activeClass ? activeStyle : inactiveStyle
                    return (
                      <li className="tab col s4" style={{ border: '1px solid #327AB7' }} key={value}><a href={href} style={style} onClick={(e) => this.setActiveTab(e)}>{value}</a></li>
                    )
                  })}
                </ul>
              }
              {this.state.commentCodesLoaded &&
                <>
                  {this.state.commentCodes.map((value) => {
                    const i = 0;
                    const id = value.typeName
                    return (
                      (id === activeTab) ?
                        <div id={id} key={value.typeName + i} className="containerv2 tabBorder" style={{ backgroundColor: '#fff', padding: '10px', border: '2px soild rgb(50, 122, 183)', height: '300px', overflow: 'scroll' }}>
                          {(value.codes.Compliment.length > 0) ? this.renderCommentCodes('Compliment', value.codes.Compliment, CommentCodeSelect.MoodColors.compliment) : null}
                          {(value.codes.Suggestion.length > 0) ? this.renderCommentCodes('Suggestion', value.codes.Suggestion, CommentCodeSelect.MoodColors.suggestion) : null}
                          {(value.codes.Neutral.length > 0) ? this.renderCommentCodes('Neutral', value.codes.Neutral, CommentCodeSelect.MoodColors.neutral) : null}
                        </div>
                        : null
                    )
                  })}
                </>
              }
            </section>
          </ModalContent>
          <ModalFooter>
            <Button type="submit" color="danger" onClick={() => this.setCommentCodes()}>
              <span>Select</span>
            </Button>
            <Button type="submit" color="white" onClick={() => this.cancelModal()}>
              <span>Cancel</span>
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}
